export default __webpack_public_path__ + "static/media/complementary--two-way-traffic--g5.23d82cc1.png";